/**
 * EventEmitter Polyfill for Matrix SDK
 * 
 * Fixes the "super.off is not a function" error in matrix-js-sdk
 * by adding the 'off' method to EventEmitter.prototype if it doesn't exist.
 * 
 * The 'off' method is an alias for 'removeListener' that was added in Node.js v10.0.0
 * but may not be available in all browser environments or polyfills.
 */

// eslint-disable-next-line no-restricted-imports
import { EventEmitter } from 'events';

// Add 'off' method to EventEmitter.prototype if it doesn't exist
// This ensures compatibility with matrix-js-sdk's TypedEventEmitter
if (EventEmitter && EventEmitter.prototype && !EventEmitter.prototype.off) {
  EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
}

// Export to ensure the polyfill is executed
export default EventEmitter;
